import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { OrderProvider } from '../providers/order.provider';
import { SelectedProductInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface UploadOrderDocumentsUseCaseParams {
    product: SelectedProductInterface;
    documents: File[];
}

@Injectable()
export class UploadOrderDocumentsUseCase implements UseCaseWithParam<UploadOrderDocumentsUseCaseParams, Observable<Transaction<void>>> {
    constructor(private orderProvider: OrderProvider) {}

    bind(params: UploadOrderDocumentsUseCaseParams): Observable<Transaction<void>> {
        return new Observable((observer) => {
            const observables: Observable<Transaction<void>>[] = [];

            if (params.documents) {
                params.documents.map((document) => {
                    observables.push(
                        this.orderProvider.upload(params.product, document).pipe(
                            map((transaction) => {
                                if (!transaction.isSuccess) {
                                    throw new Error(transaction.error);
                                }

                                return transaction;
                            })
                        )
                    );
                });
            }

            concat(...observables).subscribe({
                error: (err: Error) => {
                    observer.next(Transaction.error(err.message));
                    observer.complete();
                },
                complete: () => {
                    observer.next(Transaction.success());
                    observer.complete();
                },
            });
        });
    }
}
